import { gql } from "apollo-boost";

const SYNC_VENDOR_DMS_PRODUCT = gql`
  mutation syncVendorDmsProduct {
    syncVendorDmsProduct {
      data
      status
      error
    }
  }
`;

export default SYNC_VENDOR_DMS_PRODUCT;
